import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import podologia from "../assets/podologia.jpg";
import assistenciaTecnica from "../assets/assistencia_tecnica.jpeg";
import entregas from "../assets/entregas.jpeg";
import abotec from "../assets/abotec.png";
import ispo from "../assets/ISPO.png";
import catalogo2026 from "../assets/catalogo_2026.pdf";
import Lightbox from "./lightbox";
import './cards.css';

const LIGHTBOX_IMAGES = [
  { src: podologia, alt: "Cuidados com os pés" },
  { src: assistenciaTecnica, alt: "Assistência técnica autorizada para cadeiras de rodas motorizadas" },
  { src: entregas, alt: "Entregas em domicílio" },
];

function Cards() {
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const catalogo2026Url = `${window.location.origin}${catalogo2026}`;

  const showPrevImage = () => setLightboxIndex((current) => (current - 1 + LIGHTBOX_IMAGES.length) % LIGHTBOX_IMAGES.length);
  const showNextImage = () => setLightboxIndex((current) => (current + 1) % LIGHTBOX_IMAGES.length);

  return (
    <div className="cards cards--three-column">
      <article className="card">
        <div className="card__media">
          <button
            type="button"
            className="card__media-trigger"
            onClick={() => setLightboxIndex(0)}
            aria-label="Ampliar imagem: Cuidados com os pés"
          >
            <img className="card__media-img" src={podologia} alt="Cuidados com os pés" />
          </button>
        </div>
        <div className="card__body">
          <h3 className="card__title">Podologia</h3>
          <p className="card__text">Os cuidados que seus pés merecem</p>
        </div>
      </article>

      <article className="card">
        <div className="card__media card__media--contain">
          <button
            type="button"
            className="card__media-trigger"
            onClick={() => setLightboxIndex(1)}
            aria-label="Ampliar imagem: Assistência técnica autorizada para cadeiras de rodas motorizadas"
          >
            <img className="card__media-img" src={assistenciaTecnica} alt="Assistência técnica autorizada para cadeiras de rodas motorizadas" />
          </button>
        </div>
        <div className="card__body">
          <h3 className="card__title">Assistência técnica autorizada</h3>
          <p className="card__text">Somos assistência técnica autorizada das principais marcas de Cadeiras de Rodas Motorizadas</p>
        </div>
      </article>

      <article className="card">
        <div className="card__media card__media--contain">
          <button
            type="button"
            className="card__media-trigger"
            onClick={() => setLightboxIndex(2)}
            aria-label="Ampliar imagem: Entregas em domicílio"
          >
            <img className="card__media-img" src={entregas} alt="Entregas em domicílio" />
          </button>
        </div>
        <div className="card__body">
          <h3 className="card__title">Entregas em Domicílio</h3>
          <p className="card__text">
            <b>Faça seu pedido por telefone ou WhatsApp</b> e entregamos em sua residência! Os pedidos podem ser pagos por Pix, ou mandamos a maquininha de cartão pelo motoboy.
          </p>
        </div>
      </article>

      <article className="card card--catalogo">
        <div className="card__body card__body--center">
          <h3 className="card__title">Catálogo 2026</h3>
          <p className="card__text">
            Aponte a câmera do seu celular para o QR Code para acessar o catálogo completo
          </p>
          <a
            className="card__catalog-link"
            href={catalogo2026}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Baixar catálogo 2026 em PDF"
          >
            <QRCodeSVG
              className="card__qrcode"
              value={catalogo2026Url}
              size={192}
            />
          </a>
          <a
            className="card__catalog-url"
            href={catalogo2026}
            target="_blank"
            rel="noopener noreferrer"
          >
            Ou acesse aqui
          </a>
        </div>
      </article>

      <article className="card">
        <div className="card__body card__body--center">
          <h3 className="card__title">ISPO e ABOTEC</h3>
          <p className="card__text">
            São José Ortopédicos é uma empresa associada a ABOTEC e ISPO
          </p>
          <div className="card__logos">
            <img className="card__logo" src={abotec} alt="ABOTEC" />
            <img className="card__logo" src={ispo} alt="ISPO" />
          </div>
        </div>
      </article>

      <Lightbox
        image={lightboxIndex !== null ? LIGHTBOX_IMAGES[lightboxIndex] : null}
        onClose={() => setLightboxIndex(null)}
        onPrev={showPrevImage}
        onNext={showNextImage}
      />
    </div>
  );
}

export default Cards;
